import { useMemo, useState } from "react";
import { latestUpdates } from "@/mocks/latest";

const filters = ["全部", "今天", "昨天", "本周更早"];

function matchFilter(day: string, filter: string) {
  if (filter === "全部") return true;
  if (filter === "今天") return day === "今天";
  if (filter === "昨天") return day === "昨天";
  return day.includes("天前");
}

export default function LatestEpisodes() {
  const [active, setActive] = useState("全部");

  const list = useMemo(() => latestUpdates.filter((item) => matchFilter(item.day, active)), [active]);

  return (
    <section id="latest" className="bg-background-50">
      <div className="mx-auto max-w-[1280px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <span className="text-sm font-medium text-primary-600">最新话更新</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-3xl">
              最近更新的最新话与剧情看点
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              每次更新都会记录作品名、话数标题与主要看点，帮你快速判断哪一集值得优先补上。列表按更新时段从近到远排列。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {filters.map((filter) => (
              <button
                key={filter}
                type="button"
                onClick={() => setActive(filter)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === filter
                    ? "bg-accent-500 text-background-50"
                    : "border border-background-300 bg-background-100 text-foreground-700 hover:border-accent-400 hover:text-accent-700"
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {list.map((item) => (
            <article
              key={item.id}
              className="flex gap-3 rounded-lg border border-background-200 bg-background-100 p-3 transition-colors hover:border-accent-400 md:gap-4 md:p-4"
            >
              <div className="h-24 w-[68px] shrink-0 overflow-hidden rounded-md md:h-28 md:w-20">
                <img src={item.cover} alt={`${item.title} 最新话封面`} className="h-full w-full object-cover object-top" />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="text-sm font-medium text-foreground-950 md:text-base">{item.title}</h3>
                  <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">{item.genre}</span>
                </div>
                <p className="mt-1 text-xs font-medium text-primary-700 md:text-sm">{item.episode}</p>
                <p className="mt-1 line-clamp-2 text-xs leading-relaxed text-foreground-700">{item.note}</p>
                <div className="mt-auto flex items-center gap-2 pt-2 text-xs text-foreground-600">
                  <i className="ri-time-line"></i>
                  <span>{item.day}</span>
                  <span className="text-foreground-400">·</span>
                  <span>{item.time} 更新</span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 p-8 text-center text-sm text-foreground-600">
            该时间段暂时没有更新记录，试试切换到「全部」查看最近的更新。
          </p>
        )}
      </div>
    </section>
  );
}